import { X } from "@phosphor-icons/react";
import PrimaryButton from "components/common/buttons/PrimaryButton";
import InputField from "components/common/forms/InputField";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { postRequest } from "lib/core/apiClient";
import { useLocale } from "lib/hooks/useLocale";
import { IMAGE_CDN_URL } from "lib/utils/constants";
import React, { useState } from "react";
import { mutate } from "swr";

interface VoucherState {
  code: string;
  error: string;
  isLoading: boolean;
}

interface AddGyftrContentProps {
  setModalType: React.Dispatch<React.SetStateAction<"ADD" | "REDEEM">>;
}

const AddGyftrContent: React.FC<AddGyftrContentProps> = ({ setModalType }) => {
  const { t } = useLocale();
  const {
    state: { checkoutId },
    actions: { setCheckoutModal },
  } = useCheckoutContext();

  const [voucherState, setVoucherState] = useState<VoucherState>({
    code: "",
    error: "",
    isLoading: false,
  });

  const handleAddVoucher = async () => {
    setVoucherState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    try {
      const response: any = await postRequest(`/checkout/v2/checkout/${checkoutId}/gc/voucher/recharge`, {
        voucher_payment_mode: "GYFTR",
        voucher_code: voucherState.code,
      });
      if (response.status === "SUCCESS") {
        mutate('gc/voucher/balance');
        setModalType("REDEEM");
      } else {
        setVoucherState((prev) => ({
          ...prev,
          error: response.message,
        }));
      }
    } catch (error) {
      setVoucherState((prev) => ({
        ...prev,
        error: "Unable to process voucher. Please try again.",
      }));
    } finally {
      setVoucherState((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  };
  return (
    <>
      <button className="outline-none absolute top-4 right-4  ">
        <X
          className="h-5 w-5 cursor-pointer text-coal-dark"
          onClick={(e) => {
            e.stopPropagation();
            setCheckoutModal("NONE");
          }}
        />
      </button>
      <div className="flex flex-col items-center pt-8">
        <img src={`${IMAGE_CDN_URL}/gyftr.png`} alt="" className="h-16 w-16" />
        <h4 className="text-medium text-carbon-dark font-semibold leading-7 text-center">
          {t("save_more_gyftr")}
        </h4>
        <p className="text-xs text-gray-dark text-center">{t("gyftr_savings")}</p>
      </div>
      <div className="relative flex w-full flex-col space-y-3 px-6 pb-8 pt-4 mt-4">
        <div className="flex flex-col gap-2">
          <InputField
            type="text"
            label=""
            id="voucher_code"
            height="h-12"
            name="voucherCode"
            value={voucherState.code}
            onChange={(e) =>
              setVoucherState((prev) => ({
                ...prev,
                code: e.target.value,
                error: "",
              }))
            }
            filled={Boolean(voucherState.code?.length)}
            placeholder="Enter gift voucher code"
            autoComplete="off"
            required={false}
          />
          {voucherState.error && <p className="text-xs px-2 pb-2 text-red-dark">{voucherState.error}</p>}
        </div>

        <PrimaryButton
          buttonText={t("add_gift_voucher_to_epay")}
          onClick={() => handleAddVoucher()}
          onTouchStart={() => handleAddVoucher()}
          height="h-12"
          isLoading={voucherState.isLoading}
          isDisabled={!voucherState.code?.length}
        />
      </div>
    </>
  );
};

export default AddGyftrContent;
